// src/components/MobileNotSupported.js
import React from 'react';

const MobileNotSupported = () => {
  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      backgroundColor: '#f8f9fa',
      fontFamily: 'Roboto, sans-serif',
      padding: '20px'
    }}>
      <div>
        <h1 style={{ fontSize: '2rem', color: '#333' }}>Feature Not Supported on Mobile</h1>
        <p style={{ fontSize: '1.2rem', color: '#555', marginTop: '20px' }}>
          This functionality is available only on desktop devices.<br />
          Please login from a desktop computer to configure the application.
        </p>
      </div>
    </div>
  );
};

export default MobileNotSupported;
